import { render, staticRenderFns } from "./RoundedBox.vue?vue&type=template&id=c709df24&scoped=true"
import script from "./RoundedBox.vue?vue&type=script&lang=js"
export * from "./RoundedBox.vue?vue&type=script&lang=js"
import style0 from "./RoundedBox.vue?vue&type=style&index=0&id=c709df24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c709df24",
  null
  
)

export default component.exports